import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import productReducer from "./slices/productSlice";
import serviceReducer from "./slices/serviceSlice";
import newsReducer from "./slices/newsSlice";
import architectReducer from "./slices/architectSlice";
import bannerReducer from "./slices/bannerSlice";
import supportReducer from "./slices/supportSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    products: productReducer,
    services: serviceReducer,
    news: newsReducer,
    architects: architectReducer,
    banners: bannerReducer,
    supports: supportReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
